import React, { useEffect, useState, useContext, useMemo, useRef } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import DatePicker from "react-datepicker";
import WarningCount from "../../Asset/esocardicon/SchemaDetail/WarningCount.svg"
import ErrorCount from "../../Asset/esocardicon/SchemaDetail/ErrorCount.svg"
import moment from 'moment';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import Loader from "../../CommonLoader";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Select from 'react-select';

import "react-datepicker/dist/react-datepicker.css";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Helmet } from 'react-helmet';
import Rightsidebar from "../../Rightsidebar/Rightsidebar";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import { Commonfun, datezonechange, timezonechange, timezoneval } from '../../../NavBar/Commonfun';
import { AppContext } from "../../../../Context/Context";
import ApexCharts from "react-apexcharts";
import { Utils } from "../../../../Utils/Utils";
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import Freeaudit from "../../../../Utils/Freeaudit";
import CommonAlert from "../../../../Commonalert/commonalert"
import useMediaQuery from '@mui/material/useMediaQuery';
import TotalClickssvg from "../../Asset/esocardicon/Branded_NonBranded/TotalClicks.svg"
import TotalImpressionssvg from "../../Asset/esocardicon/Branded_NonBranded/TotalImpressions.svg"
import DatagridComp from "../../DatagridComp";
import PdfandCsv from "../../PdfandCsv";
import Commoncard from "../../Commoncard";
import { CommonErrorAlert } from "../../../../Commonalert/commonErrorAlert";
import CommonBreadCrumb from "../../../../Commonalert/commonbreadcrumb";
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Box from "@mui/material/Box";
import { customDropdownStyles } from "../../../../Commonalert/commonDropdown";
import UserActivityTracker from "../../../../hooks/userActivityTracker";
import Chart from "react-apexcharts";
import ScoreGauge from "../../../../Components/chart/gaugeChart";
import { Card, Typography } from "@mui/material";



const VulnerabilityAudit = () => {

    const { isMenuExpanded, setIsMenuExpanded } = useContext(AppContext);
    const esodata = useSelector((state) => state);
    const ApiToken = esodata.apiauthkey.value;
    const [buttnval, setMenubutval] = useState('byIssue')
    const SevenDaysBefore = moment().subtract(7, 'd').toDate();
    const [startDate, setStartDate] = useState(SevenDaysBefore);
    const [EndDate, SetEndDate] = useState(new Date());
    const [cardData, setCardData] = useState([]);
    const rows = cardData;
    const [loading, setLoading] = useState(false);
    const [TableErrorMessage, SetTableErrorMessage] = useState('')
    const [autoheightval, SetAutoheightval] = useState(true)
    const [faqData, setfaqData] = useState("2")
    const [toggle, setToggle] = useState(false);
    const [initialfaqDateval, SetInitialfaqDateval] = useState([]);
    const [apiopen, setapiOpen] = React.useState(false);
    const [apierrorMsg, setapierrorMsg] = useState();
    const [openCommonAlerts, setOpenCommonAlerts] = useState(false);
    const [brandType, setBrandType] = useState({ label: 'impressions', value: 'Impressions' });
    const isMobile = useMediaQuery('(max-width:600px)');
    const isTablet = useMediaQuery('(min-width:600px) and (max-width:900px)');
    const [freesiteaudit, setfreesiteaudit] = useState({ status: true, error: "" });
    const [freesiteaudit1, setfreesiteaudit1] = useState({ status: true, error: "" });
    const [isDownloading, setIsDownloading] = useState(false);
    const [isDownloadingcsv, setIsDownloadingcsv] = useState(false);
    const [tableLoading, setTableLoading] = useState(true);
    const [first, setfirst] = useState({ name: "", path: "", closeName: "Close", statusDomain: false });
    const [checkD, setcheckD] = useState(false);
    const [domainNameUrl, setDomainNameUrl] = useState({ domain_name: '', domain_url: '' });
    const [totalErrorCount, setTotalErrorCount] = useState(0);
    const [totalWarningCount, setTotalWarningCount] = useState(0);
    const [selectedIssueType, setSelectedIssueType] = useState('error');
    const [jobDate, setjobDate] = useState("");
    let detailurl = `${process.env.REACT_APP_DOMAIN}vulnerabiity-detail/`;

    //filter
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [selectedJobDate, setSelectedJobDate] = useState(null);
    const [prevSelectedJobDate, setPrevSelectedJobDate] = useState(null);
    const [jobDateOptions, setJobDateOptions] = useState([]);
    //run report
    const [isReportOpen, setIsReportOpen] = useState(false);
    const [successApiopen, setSuccessApiOpen] = useState(false);
    const [successApierrorMsg, setSucessApierrorMsg] = useState('');
    const [summaryData, setSummaryData] = useState({
        "security_health_score": 0,
        "severity_distribution": {
            "high": 0,
            "medium": 0,
            "low": 0,
            "warning": 0
        },
        "historical_trend": []
    });


    const navigate = useNavigate();

    const apihandleClose = () => {
        setapiOpen(false);
    };


    const columns = [
        {
            field: "name",
            headerName: "Issue Name",
            minWidth: 200,
            flex: 1,
            headerAlign: "center",
            align: "center",
            sortable: true,
            disableClickEventBubbling: true,
            description: "The name or title of the security issue detected in the audit."
        },
        {
            field: "issue_type",
            headerName: "Issue Type",
            minWidth: 200,
            flex: 1,
            headerAlign: "center",
            align: "center",
            sortable: true,
            disableClickEventBubbling: true,
            description: "The severity level of the security issue"
        },
        {
            field: "count",
            headerName: selectedIssueType === 'error' ? 'Error Count' : 'Warning Count',
            minWidth: 200,
            flex: 1,
            headerAlign: "center",
            align: "center",
            sortable: true,
            disableClickEventBubbling: true,
            description: selectedIssueType === 'error' ? 'The number of errors(high medium low) detected in the audit  in that issue name' : 'The number of warnings detected in the audit  in that issue name'
        },
        {
            field: "Action",
            headerName: "Action",
            description: 'Click to view the detailed report',
            minWidth: 130,
            flex: 1,
            headerAlign: "center",
            align: "center",
            sortable: false,
            headerClassName: "hide_option",
            renderCell: (cardData) => {
                const selectedType = buttnval === 'byIssue' ? 'issue_type' : 'url';
                return (
                    <a href={detailurl + `${cardData.row.id}` + "/" + `${selectedType}`}>
                        <button className="view-report-button">View Report</button>
                    </a>
                );
            },
        },
    ];

    const columns1 = [
        {
            field: "url",
            headerName: "URL",
            minWidth: 200,
            flex: 1,
            headerAlign: "center",
            align: "center",
            sortable: true,
            disableClickEventBubbling: true,
            description: "The URL associated with the security issue."
        },
        {
            field: "error_count",
            headerName: "Error Count",
            minWidth: 200,
            flex: 1,
            headerAlign: "center",
            align: "center",
            sortable: true,
            disableClickEventBubbling: true,
            description: "The number of errors(high medium low) detected in the audit  in that issue name"
        },
        {
            field: "warning_count",
            headerName: "Warning Count",
            minWidth: 200,
            flex: 1,
            headerAlign: "center",
            align: "center",
            sortable: true,
            disableClickEventBubbling: true,
            description: "The number of warnings detected in the audit  in that issue name"
        },
        {
            field: "Action",
            headerName: "Action",
            description: "Click to view the detailed report",
            minWidth: 130,
            flex: 1,
            headerAlign: "center",
            align: "center",
            sortable: false,
            headerClassName: "hide_option",
            renderCell: (cardData) => {
                const selectedType = buttnval === 'byIssue' ? 'issue_type' : 'url';
                return (
                    <a href={detailurl + `${cardData.row.id}` + "/" + `${selectedType}`}>
                        <button className="view-report-button">View Report</button>
                    </a>
                );
            },
        },
    ];

    const menuChange = (e) => {
        setMenubutval(e.target.id)
        callUserdataApi();
        faqdatafun(e.target.id)
    }

    useEffect(() => {
        faqdatafun()
        GetuserDatavalue();
        fetchFilterOptions();
    }, [])

    const GetuserDatavalue = async () => {
        try {
            const datavalue = await axios.get(
                `${process.env.REACT_APP_API_URL}accounts/get_user_details/`,
                {
                    headers: {
                        Authorization: `${ApiToken}`,
                    },
                }
            ).catch((error) => {

                if (error?.response?.status == 599 || error?.response?.status == 500 || error?.response?.status == 400 || error?.response?.status == 404) {
                    navigate('/errorpages');
                }
                else if (error?.code == "ERR_NETWORK") {
                    navigate('/errorpages');
                }

            });
            if (datavalue?.data?.dor_domain_name && datavalue?.data?.dor_domain_url) {
                setDomainNameUrl({ ...domainNameUrl, domain_name: datavalue?.data?.dor_domain_name, domain_url: datavalue?.data?.dor_domain_url });
            }
            if (datavalue?.data) {
                if (datavalue?.data?.is_location_required === true) {
                    setfirst({ ...first, name: "Verify Now", path: "/Userdata", statusDomain: true });
                    return
                }
                if (datavalue?.data?.is_domain_required === true) {
                    setfirst({ ...first, name: "Verify Now", path: "/Impadddomain", statusDomain: true });
                    return
                }
                if (datavalue?.data?.is_domain_ownership_required === true) {
                    setfirst({ ...first, name: "Verify Now", path: "/Domainownership", statusDomain: true });
                    return
                }

            }

        } catch (err) {
            console.log(err);
        }
    };

    const fetchFilterOptions = async () => {
        try {
            const jobDOptions = await axios
                .get(
                    `${process.env.REACT_APP_API_URL}domain/get_report_job_details/?user_domain_id=${esodata.domaindata.value.header_selected}&job_type=security_audit&audit_type=vulnerability_audit`,
                    {
                        headers: {
                            Authorization: `${ApiToken}`,
                        },
                    },
                )
                .catch((error) => {
                    if (
                        error?.response?.status == 599 ||
                        error?.response?.status == 400 ||
                        error?.response?.status == 500
                    ) {
                        setapiOpen(true);
                        setapierrorMsg(error?.response?.data?.error);
                    } else if (
                        error?.code == "ERR_NETWORK" ||
                        error?.response?.status == 404
                    ) {
                        navigate("/errorpages");
                    }
                });
            if (jobDOptions?.data) {
                if (jobDOptions.data.jobs) {
                    var Sections = [];
                    jobDOptions.data.jobs.forEach((element) => {
                        Sections.push({ label: datezonechange(element.completed_at), value: element.id });
                    });
                    setJobDateOptions(Sections);
                }
            }
        } catch (err) { }
    };

    const callUserdataApi = async (issueType = 'error') => {
        setLoading(true);
        setTableLoading(true);
        const selectedType = buttnval === 'byIssue' ? 'issue_type' : 'url';
        const jobId = selectedJobDate ? selectedJobDate : { label: '', value: '' };

        const datavalue = await axios.get(
            // `${process.env.REACT_APP_API_URL}security_tools/git_audit/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${jobId}&formats=''&timezone=''`, {
            `${process.env.REACT_APP_API_URL}security_tools/vulnerability_report/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${jobId.value}&formats=''&type=${selectedType}&timezone=${timezoneval()}&issue=${issueType}`, {
            headers: {
                Authorization: `${ApiToken}`,
            },
        }
        ).catch((error) => {
            if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
                setapiOpen(true);
                if (error?.response?.data?.security_config) {
                    const securityError = <div dangerouslySetInnerHTML={{ __html: error?.response?.data?.security_config }} />
                    setapierrorMsg(securityError);
                } else {
                    setapierrorMsg(error?.response?.data?.error)
                }
            }
            else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
                navigate('/errorpages')
            }
        });
        if ((datavalue?.data?.issue_summary || datavalue?.data?.url_summary) && (datavalue?.data?.issue_summary?.length > 0 || datavalue?.data?.url_summary?.length > 0)) {
            const selectedType1 = buttnval === 'byIssue' ? 'issue_summary' : 'url_summary';
            const dataval = datavalue?.data[selectedType1];
            setjobDate(moment(datavalue?.data?.job_date).format("MMMM DD,YYYY HH:mm"));
            setTotalErrorCount(datavalue?.data?.total_error_count);
            setTotalWarningCount(datavalue?.data?.total_warning_count);
            SetAutoheightval(false)

            const newData = dataval.map((obj, index) => {
                return { ...obj, sid: index + 1 };
            });
            setCardData(newData);
        }
        else {
   
    SetAutoheightval(true);
    setCardData([]); 
    setTotalErrorCount(0);
    setTotalWarningCount(0);
    setjobDate(""); 
    setSummaryData({
        "security_health_score": 0,
        "severity_distribution": {
            "high": 0,
            "medium": 0,
            "low": 0,
            "warning": 0
        },
        "historical_trend": []
    });
}

        if (datavalue?.data) {
            setSummaryData({
                "security_health_score": datavalue?.data?.charts?.security_health_score || 0,
                "severity_distribution": {
                    "high": datavalue?.data?.charts?.severity_distribution?.high || 0,
                    "medium": datavalue?.data?.charts?.severity_distribution?.medium || 0,
                    "low": datavalue?.data?.charts?.severity_distribution?.low || 0,
                    "warning": datavalue?.data?.charts?.severity_distribution?.warning || 0
                },
                "historical_trend": datavalue?.data?.charts?.historical_trend || []
            })
        }

        setTableLoading(false);
        setLoading(false);
    };

    const pdfdown = async () => {
        setLoading(true);
        setIsDownloading(true);
        const jobId = selectedJobDate ? selectedJobDate : { label: '', value: '' };
        const selectedType = buttnval === 'byIssue' ? 'issue_type' : 'url';

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}security_tools/vulnerability_report/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${jobId.value}&formats=pdf&type=${selectedType}&timezone=${timezoneval()}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/pdf',
                    Authorization: `${ApiToken}`,
                },
            });
            if (response.ok) {
                const blob = await response.blob();
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);

                var filedata = await Commonfun("vulnerabilityaudit", "pdf", ApiToken, esodata.domaindata.value.header_selected);

                link.download = filedata;
                link.click();
                window.URL.revokeObjectURL(link.href);
            } else {
                if (response?.status == 599 || response?.status == 500 || response?.status == 400 || response?.status == 404) {
                    response.json().then(data => {
                        setapiOpen(true);
                        setapierrorMsg(data?.error)
                    })
                }
                else if (response?.code == "ERR_NETWORK") {
                    navigate('/errorpages')
                }
            }
        } catch (error) {
            toast.error("No Data", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });

            console.error('Error during PDF download:', error);
        }
        setLoading(false);
        setIsDownloading(false);

    }

    const csvdown = async () => {
        setLoading(true);
        setIsDownloadingcsv(true);
        const jobId = selectedJobDate ? selectedJobDate : { label: '', value: '' };
        const selectedType = buttnval === 'byIssue' ? 'issue_type' : 'url';

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}security_tools/vulnerability_report/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${jobId.value}&formats='csv'&type=${selectedType}&timezone=${timezoneval()}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/pdf',
                    Authorization: `${ApiToken}`,
                },
            });
            if (response.ok) {
                const blob = await response.blob();
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                var filedata = await Commonfun("vulnerabilityaudit", "csv", ApiToken, esodata.domaindata.value.header_selected);

                link.download = filedata;
                link.click();

                window.URL.revokeObjectURL(link.href);
            } else {
                if (response?.status == 599 || response?.status == 500 || response?.status == 400 || response?.status == 404) {
                    response.json().then(data => {
                        setapiOpen(true);
                        setapierrorMsg(data?.error)
                    })
                }
                else if (response?.code == "ERR_NETWORK") {
                    navigate('/errorpages')
                }
            }
        } catch (error) {
            toast.error("No Data", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });

            console.error('Error during PDF download:', error);
        }
        setLoading(false);
        setIsDownloadingcsv(false);
    }

    const faqdatafun = async (menubutval = "") => {
        try {
            const doaminsectiondatavalue = await axios.get(
                `${process.env.REACT_APP_API_URL}domain/frequently_asked_questions/?menu=75`,
                {
                    headers: {
                        Authorization: `${ApiToken}`,
                    },
                }
            ).catch((error) => {
                if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
                    setapiOpen(true);
                    setapierrorMsg(error?.response?.data?.error)
                }
                else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
                    navigate('/errorpages')
                }
            });
            if (doaminsectiondatavalue?.data) {
                SetInitialfaqDateval(doaminsectiondatavalue?.data?.faqs)
            }
        } catch (err) { }
    }
    const handleToggle = () => {
        if (faqData != 1) {
            setfaqData(1)
        }
        else {
            setfaqData(2)
        }
        setToggle((pre) => !pre);
    };

    const freeAudit = async () => {
        if (buttnval === "brand") {
            const check = await Utils("branded_keywords", ApiToken);
            setfreesiteaudit({ status: true, error: "" });
            setfreesiteaudit1({ status: true, error: "" });
        } else if (buttnval === "byUrl") {
            const check1 = await Utils("non_branded_keywords", ApiToken);
            setfreesiteaudit1({ status: true, error: "" });
            setfreesiteaudit({ status: true, error: "" });
        }
    }

    useEffect(() => {
        freeAudit();
        callUserdataApi();
    }, [buttnval])

    const [download, setDownload] = useState(false);
    const dropdownRef = useRef();

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDownload(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleDownlodingCSV = () => {
        csvdown();
    }

    const handleDownlodingPDF = () => {
        pdfdown();
    }

    const handleModelPopUp = () => {
        openModal();
    }

    function openModal() {
        setIsFilterOpen(true);
    }

    function closeModal() {
        setIsFilterOpen(false);
        setSelectedJobDate(prevSelectedJobDate);
    }

    const filterNow = () => {
        const jobId = selectedJobDate ? selectedJobDate : { label: '', value: '' };
        callUserdataApi();
        setPrevSelectedJobDate(jobId);
        setIsFilterOpen(false);
    }

    const handleReset = () => {
        setSelectedJobDate(null);
    }

    //Run report

    const closeRunReport = () => {
        setIsReportOpen(false);
    }

    const runReportNow = async () => {
        setLoading(true);

        const datavalue = await axios.get(
            `${process.env.REACT_APP_API_URL}security_tools/run_security_report/?user_domain_id=${esodata.domaindata.value.header_selected}&report_type=vulnerability_audit`, {
            headers: {
                Authorization: `${ApiToken}`,
            },
        }
        ).catch((error) => {
            if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
                setapiOpen(true);
                setapierrorMsg(error?.response?.data?.error)
            }
            else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
                navigate('/errorpages')
            }
        });
        if (datavalue?.status === 200) {
            setSuccessApiOpen(true);
            setSucessApierrorMsg(datavalue?.data?.success);
        }

        setIsReportOpen(false);
        setLoading(false);
    };

    const successApiClose = () => {
        setSuccessApiOpen(false);
    }

    const SwitchActiveTableTab = (issueType) => {
        setSelectedIssueType(issueType)
        callUserdataApi(issueType);
    }

    const cardDatas = [
        {
            route: 'error',
            title: "Error Count",
            value: totalErrorCount,
            iconSrc: ErrorCount,
            altText: "Error Count",
            iconColor: 1,
            bgColor: 1,
            handleCardClick: buttnval === 'byIssue' ? SwitchActiveTableTab : null
        },
        {
            route: 'warning',
            title: "Warning Count",
            value: totalWarningCount,
            iconSrc: WarningCount,
            altText: "Warning Count",
            iconColor: 2,
            bgColor: 2,
            handleCardClick: buttnval === 'byIssue' ? SwitchActiveTableTab : null
        }
    ];

    const gaugeChart = () => {
        return (
            <div>
                {/* <span>Most Critical issue category</span> */}
                <ScoreGauge score={summaryData.tech_engagement_score} width={'120px'} />
            </div>
        )
    }

    const urls = Array.isArray(summaryData?.historical_trend)
        ? summaryData.historical_trend
        : [];

    const chartOptions = {
        chart: {
            type: "bar",
            toolbar: { show: false }
        },
        colors: ["#0a783f", "#d49f2d"],
        plotOptions: {
            bar: {
                horizontal: false, // better for long URLs
                barHeight: "60%"
            }
        },
        xaxis: {
            categories: urls?.map(item => item.date) || [],
            labels: {
                show: false   // 👈 hides numbers/text on x-axis
            },
            axisBorder: {
                show: false   // optional: remove axis line
            },
            axisTicks: {
                show: false   // optional: remove ticks
            }
        },
        yaxis: {
            labels: {
                maxWidth: 150
            }
        },
        grid: {
            padding: {
                left: 20,
                right: 20
            }
        },
        tooltip: {
            x: {
                formatter: (val, opts) => urls[opts.dataPointIndex]?.date
            },
            y: {
                formatter: (val) => val
            }
        }
    };

    const chartSeries = [
        {
            name: "Errors",
            data: urls?.map(item => item.errors) || []
        },
        {
            name: "Warnings",
            data: urls?.map(item => item.warnings) || []
        }
    ];


    return (
        <div className={`over_all_container brand_container ${isMenuExpanded ? "blur overflow-hidden" : ""}`} >
            <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
            <Helmet>
                <meta charSet="utf-8" />
                <title>Vulnerability Audit</title>
            </Helmet>
            <CommonAlert setOpenCommonAlerts={setOpenCommonAlerts} />
            {
                loading === true ? <Loader /> : null
            }

            <Container maxWidth={false} className="dashboard-container">
                <Box className="dashboard-box">
                    <Grid container className="dashboard-grid">
                        <Grid item xs={12} md={4}>
                            <div>
                                <h1 className="dashboard_header">
                                    Vulnerability Audit
                                    <span className="faq-chip" onClick={handleToggle}>FAQ's</span>
                                </h1>
                            </div>
                        </Grid>
                        <Grid item xs={12} md={8}>
                            <div className="top_breadcrumb_menu">
                                <div className="exportpdf_outer">
                                    <div className="breadcrumb-wrapper">
                                        <CommonBreadCrumb breadcrumbValue={[
                                            { title: 'Security Tools' },
                                            { title: 'Vulnerability Audit', activeColor: true }
                                        ]} />
                                    </div>
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                </Box>
            </Container>

            <Container maxWidth={false} className="dashboard-container">
                <Box className="dashboard-box-time">
                    <Grid container className="dashboard-grid">
                        <Grid item xs={12} md={6}>
                            <div className="time_zone">
                                <span className="timezone-date">{timezonechange(jobDate)} </span><br />
                                <span className="timezone-val">{timezoneval()}</span>
                            </div>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <div className="drop_down_button" >
                                <button
                                    title="Security Audit Settings"
                                    className="btn_dashboard"
                                    onClick={() => navigate('/security-audit-settings')}
                                >
                                    Security Audit Settings
                                </button>
                                <button
                                    title="Run Report"
                                    className="btn_dashboard"
                                    onClick={() => setIsReportOpen(true)}
                                // onClick={() => {
                                //   if (first.statusDomain) {
                                //     setcheckD(first.statusDomain);
                                //   } else {

                                //     setfaqData(2);
                                //     setToggle(false);
                                //     SetRunReportPopShow(true);
                                //   }
                                // }}
                                // disabled={!analysisSummaryPlan.status}
                                >
                                    Run Report Now
                                </button>
                            </div>
                        </Grid>
                    </Grid>
                </Box>
            </Container>


            <Container maxWidth={false} className="dashboard-container">
                <Box className="dashboard-box-tab">
                    <Grid container className="dashboard-grid">
                        <Grid item xs={12} md={12}>
                            <div className="trendy-tabs-wrapper">
                                <div className="trendy-tab-container">
                                    <button type="button" id='byIssue' onClick={e => menuChange(e)}
                                        className={`trendy-tab ${buttnval === "byIssue" ? "active" : ""}`}  >By Issue</button>
                                    <button type="button" id='byUrl' onClick={e => menuChange(e)}
                                        className={`trendy-tab ${buttnval === "byUrl" ? "active" : ""}`}  >By URL</button>
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                </Box>
            </Container>

            <Container maxWidth={false} sx={{ maxWidth: "1500px" }} style={{ marginTop: "50px", marginBottom: "40px" }} >
                <Box>
                    <Grid container style={{ display: "flex", alignItems: "center" }} >
                        <Grid container spacing={3} justifyContent="center">
                            {freesiteaudit.status && buttnval === "byIssue" ?

                                <>
                                    {cardDatas.map((item, index) => (
                                        <Grid item xs={12} sm={6} md={3} key={index}>
                                            <Commoncard
                                                item={item}
                                                nonclikable={false}
                                            />
                                        </Grid>
                                    ))}
                                    <Grid item xs={12} md={3}>
                                        <Card
                                            sx={{
                                                borderRadius: "16px",
                                                boxShadow: "0 6px 16px rgba(0, 0, 0, 0.08)",
                                                transition: "0.3s",
                                                cursor: "default",
                                                height: "100%",
                                                // border: 1px solid #e0e0e0;
                                                "&:hover": {
                                                    transform: "translateY(-5px)",
                                                    boxShadow: "0 6px 16px rgba(0, 0, 0, 0.10)",
                                                },
                                                overflow: "hidden",
                                                border: "none"
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    backgroundColor: '#d1fae5',
                                                    p: 2.5,
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                }}
                                            >

                                                <Typography
                                                    variant="h4"
                                                    sx={{
                                                        fontWeight: 700,
                                                        fontSize: "2rem",
                                                        background: "linear-gradient(to right, #1f2937, #4b5563)",
                                                        WebkitBackgroundClip: "text",
                                                        WebkitTextFillColor: "transparent",
                                                        textShadow: "0 1px 1px rgba(0,0,0,0.1)",
                                                        letterSpacing: 1,
                                                    }}
                                                >
                                                    <div style={{ justifySelf: 'center', marginTop: '1rem' }}>{summaryData.security_health_score}<span style={{ fontSize: '14px', marginLeft: '5px' }}>out of 100</span></div>
                                                </Typography>
                                                <Box
                                                    sx={{
                                                        // backgroundColor: '#7c3aed',
                                                        color: "#059669",
                                                        // p: 1.5,
                                                        borderRadius: "50%",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        fontSize: "1.5rem",
                                                    }}
                                                >
                                                    {/* {icon} */}
                                                    {gaugeChart()}
                                                </Box>
                                            </Box>

                                            <Box
                                                sx={{
                                                    background: "#fff",
                                                    px: 2.5,
                                                    py: 3,
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    textTransform: "uppercase",
                                                }}
                                            >
                                                <Typography
                                                    sx={{ fontWeight: 600, fontSize: "0.85rem", color: "#1f2937" }}
                                                >
                                                    Security Health Score
                                                </Typography>
                                            </Box>
                                        </Card>
                                    </Grid>
                                </> : null
                            }
                            {freesiteaudit1.status && buttnval === "byUrl" ?

                                <>
                                    {cardDatas.map((item, index) => (
                                        <Grid item xs={12} sm={6} md={3} key={index}>
                                            <Commoncard
                                                item={item}
                                                nonclikable={true}
                                            />
                                        </Grid>
                                    ))}
                                    <Grid item xs={12} md={3}>
                                        <Card
                                            sx={{
                                                borderRadius: "16px",
                                                boxShadow: "0 6px 16px rgba(0, 0, 0, 0.08)",
                                                transition: "0.3s",
                                                cursor: "default",
                                                height: "100%",
                                                // border: 1px solid #e0e0e0;
                                                "&:hover": {
                                                    transform: "translateY(-5px)",
                                                    boxShadow: "0 6px 16px rgba(0, 0, 0, 0.10)",
                                                },
                                                overflow: "hidden",
                                                border: "none"
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    backgroundColor: '#d1fae5',
                                                    p: 2.5,
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                }}
                                            >

                                                <Typography
                                                    variant="h4"
                                                    sx={{
                                                        fontWeight: 700,
                                                        fontSize: "2rem",
                                                        background: "linear-gradient(to right, #1f2937, #4b5563)",
                                                        WebkitBackgroundClip: "text",
                                                        WebkitTextFillColor: "transparent",
                                                        textShadow: "0 1px 1px rgba(0,0,0,0.1)",
                                                        letterSpacing: 1,
                                                    }}
                                                >
                                                    <div style={{ justifySelf: 'center', marginTop: '1rem' }}>{summaryData.security_health_score}<span style={{ fontSize: '14px', marginLeft: '5px' }}>out of 100</span></div>
                                                </Typography>
                                                <Box
                                                    sx={{
                                                        // backgroundColor: '#7c3aed',
                                                        color: "#059669",
                                                        // p: 1.5,
                                                        borderRadius: "50%",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        fontSize: "1.5rem",
                                                    }}
                                                >
                                                    {/* {icon} */}
                                                    {gaugeChart()}
                                                </Box>
                                            </Box>

                                            <Box
                                                sx={{
                                                    background: "#fff",
                                                    px: 2.5,
                                                    py: 3,
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    textTransform: "uppercase",
                                                }}
                                            >
                                                <Typography
                                                    sx={{ fontWeight: 600, fontSize: "0.85rem", color: "#1f2937" }}
                                                >
                                                    Security Health Score
                                                </Typography>
                                            </Box>
                                        </Card>
                                    </Grid>
                                </> : null
                            }
                        </Grid>
                    </Grid>
                </Box>
            </Container>

            <Container maxWidth={false} className="dashboard-container">
                <Grid container spacing={2} style={{ marginBottom: '20px' }}>

                    <Grid item xs={12} md={4}>
                        <Box className="grid_table_shodow" style={{ padding: '15px', height: '300px' }}>
                            <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '10px' }}>Severity Distribution</Typography>
                            <Chart
                                type="donut"
                                height={280}
                                series={Object.values(summaryData.severity_distribution)}
                                options={{
                                    labels: Object.keys(summaryData.severity_distribution),
                                    legend: { position: 'bottom', fontSize: '10px' },
                                    dataLabels: { enabled: false }
                                }}
                            />
                        </Box>
                    </Grid>

                    <Grid item xs={12} md={8}>
                        <Box className="grid_table_shodow" style={{ padding: '15px', height: '300px' }}>
                            <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '10px' }}>Historical Trend</Typography>
                            <Chart
                                options={chartOptions}
                                series={chartSeries}
                                type="bar"
                                height={270}
                            />
                        </Box>
                    </Grid>

                </Grid>
            </Container>

            <Container maxWidth={false} className="dashboard-container">
                <Box className="grid_table_shodow">
                    <Grid container className="dashboard-grid">
                        <Grid item xs={12} md={12}>
                            <div className="cnt_audit_outer_wrap">
                                {(freesiteaudit.status && buttnval === "byIssue") ?
                                    <>
                                        <DatagridComp
                                            columns={columns}
                                            rows={rows}
                                            autoheightval={autoheightval}
                                            datagridval={2}
                                            columnFreezeWidth={[0]}
                                            tableLoading={tableLoading}
                                            handleModelPopUp={handleModelPopUp}
                                            handleDownlodingCSV={handleDownlodingCSV}
                                            handleDownlodingPDF={handleDownlodingPDF}
                                            customFilter={true}
                                            DownloadShowFile={true}
                                            DownloadShowPDF={1}
                                            DownloadShowCSV={2}
                                            localeText={{ noRowsLabel: 'No report available' }}
    noRowsMessage="No report available" 
                                        />
                                        <UserActivityTracker pagename="Security Tools- By Issue Vulnerability" />
                                    </> : null
                                }

                                {(freesiteaudit1.status && buttnval === "byUrl") ?
                                    <>
                                        <DatagridComp
                                            columns={columns1}
                                            rows={rows}
                                            autoheightval={autoheightval}
                                            datagridval={2}
                                            columnFreezeWidth={[0]}
                                            tableLoading={tableLoading}
                                            handleModelPopUp={handleModelPopUp}
                                            handleDownlodingCSV={handleDownlodingCSV}
                                            handleDownlodingPDF={handleDownlodingPDF}
                                            customFilter={true}
                                            DownloadShowFile={true}
                                            DownloadShowPDF={1}
                                            DownloadShowCSV={2}
                                            localeText={{ noRowsLabel: 'No report available' }}
                                            noRowsMessage="No report available" 
                                            
                                        />

                                        <UserActivityTracker pagename="Security Tools- By Url Vulnerability" />
                                    </> : null
                                }

                                {
                                    !freesiteaudit.status && buttnval === "byIssue" ? <Freeaudit planStatus={freesiteaudit} /> : null
                                }

                                {
                                    !freesiteaudit1.status && buttnval === "byUrl" ? <Freeaudit planStatus={freesiteaudit1} /> : null
                                }
                            </div>
                        </Grid>
                    </Grid>
                </Box>
            </Container>


            <Container maxWidth={false} className="footer-container">
                <Box className="footer-box">
                    <Grid container className="footer-grid">
                        <Grid item xs={12} md={6}>
                            <div className="footer-left">
                                <p className="footer-text">
                                    All Rights Reserved Copyright © 2026 |
                                    <a href="https://www.elitesiteoptimizer.ai/" target="_blank"> <span className="footer-brand"> Elite site Optimizer</span></a>
                                </p>
                            </div>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <div className="footer-right">
                                <p>{/* Add content if needed */}</p>
                            </div>
                        </Grid>
                    </Grid>
                </Box>
            </Container>

            {toggle && <Rightsidebar close={() => setToggle(false)} setToggle={setToggle} initialfaqDateval={initialfaqDateval} />}

            <Dialog
                open={isFilterOpen}
                onClose={closeModal}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className="competitor_test_filter job_date_filter over_all_accessibility"
            >
                <DialogTitle className="keyword-dialog-header ">
                    {"Filter By"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        <div className="cnt_hdr_blw_wrap row">
                            <div>
                                <div >
                                    <div>
                                        <span className="select_filter_text">Completed Date</span>
                                        <Select
                                            value={selectedJobDate}
                                            options={jobDateOptions}
                                            placeholder="Select..."
                                            labelField="completed_at"
                                            valueField="id"
                                            onChange={(values) => {
                                                setSelectedJobDate(values);
                                            }}
                                            styles={customDropdownStyles()}
                                            menuPortalTarget={document.body}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="dialog-action-button">
                    <button
                        className="form_submit_btn"
                        onClick={filterNow}
                        style={{ cursor: "pointer" }}
                    >
                        Submit
                    </button>
                    <button style={{ cursor: "pointer" }} onClick={closeModal}>
                        close
                    </button>
                    <button
                        className="form_submit_btn"
                        style={{ cursor: "pointer" }}
                        onClick={handleReset}
                    >
                        Reset
                    </button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={isReportOpen}
                onClose={closeRunReport}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className="competitor_test_filter job_date_filter over_all_accessibility"
            >
                <DialogTitle className="keyword-dialog-header ">
                    {"Run Report"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        <div>
                            Can we run the report for Vulnerability Audit ?
                        </div>
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="dialog-action-button">
                    <button
                        className="form_submit_btn"
                        onClick={runReportNow}
                        style={{ cursor: "pointer" }}
                    >
                        Run
                    </button>
                    <button style={{ cursor: "pointer" }} onClick={closeRunReport}>
                        Cancel
                    </button>
                </DialogActions>
            </Dialog>

            <CommonErrorAlert
                data={{
                    apiopen: successApiopen,
                    apiErrorMsg: successApierrorMsg,
                    isIconStyled: false
                }}
                closeAlert={successApiClose} />

            {!openCommonAlerts &&
                <CommonErrorAlert
                    data={{
                        apiopen: apiopen,
                        apiErrorMsg: apierrorMsg,
                        isIconStyled: true
                    }}
                    closeAlert={apihandleClose} />
            }

            <Dialog
                open={checkD}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className="domain-verify-alert"
            >
                <DialogTitle className="keyword-dialog-header"><ReportProblemIcon fontSize="large" sx={{ color: '#ff601f' }} /></DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: '15px', lineHeight: '1px', width: "max-content" }}>
                            <p>{"Please verify your domain ("}<a href={domainNameUrl.domain_url} title={`go to this link ${domainNameUrl.domain_url}`} >{domainNameUrl.domain_name}</a>{") to access these features"}</p>
                        </div>
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="dialog-action-button">
                    <Button onClick={() => { navigate(first.path) }} >{first.name}</Button>
                    <Button onClick={() => setcheckD(false)} >{first.closeName}</Button>
                </DialogActions>
            </Dialog>
        </div>
    )

}
export default VulnerabilityAudit